import { render, staticRenderFns } from "./billAddCustomer.vue?vue&type=template&id=b576e798"
import script from "./billAddCustomer.vue?vue&type=script&lang=js"
export * from "./billAddCustomer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports